<template>
    <dialog-generic :visibility.sync='visibility' :indicator='indicator'>
                <template v-slot:title> Фразы </template>
        <template v-slot:content>
            <div class='py-2 text-center'>Удалить фразы?</div>
        </template>
        <template v-slot:action>
            <v-btn class='px-0 red--text text--darken-2' :loading='indicator' block depressed @click='deleteWordStatplace'>
                Удалить
            </v-btn>
        </template>
    </dialog-generic>
</template>

<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'WordstatplaceDeleteDialog',
        props: ['data', 'postAction', 'projectId', 'initialState'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visibility: this.initialState,
                wordstatplace: this.data,
                indicator: false,
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            },
            data(value) {
                this.statplace = value
            }
        },

        methods: {
            deleteWordStatplace() {
                this.indicator = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                };
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'id': this.data.id
                }
                this.$http.patch(this.$store.getters.endpoint + '/db/project/' + this.projectId + '/wordstatplaces',
                    requestData,
                    {headers: {...this.$store.state.restrictedHeaders,...requestHeaders}}
                ).then( (r) => {
                    this.postAction('statplaces')
                    this.visibility = false;
                    this.indicator = false;
                });
            }
        }

    }
</script>
